export const amazonLexPrebuiltEntityMappings = {
    "Date": "AMAZON.DATE",
    "Email": "AMAZON.EmailAddress",
    "Location": "AMAZON.AT_CITY",
    "Number": "AMAZON.NUMBER",
    "Percentage": "AMAZON.Percentage",
    "PersonalName": "AMAZON.Person",
    "PhoneNumber": "AMAZON.PhoneNumber",
}